import { Message, Loading } from 'element-ui';
import { getToken } from '@/utils/token'
import router from '@/router'
import { GetParam } from '@/utils/param'

const Qs = require('qs');
// 配置API接口地址
var root = process.env.API_ROOT//'/mod'
// var root = 'http://192.168.112.68:56627/mod'
//'/mod'
// 引用axios
var axios = require('axios')

let loading        //定义loading变量

function startLoading() {    //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.1)'
  })
}
function endLoading() {    //使用Element loading-close 方法
  loading.close()
}

let needLoadingRequestCount = 0

export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

//拦截器 每次调用接口时打开遮罩
axios.interceptors.request.use(
  config => {
    showFullScreenLoading()
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);
//拦截器 接口返回值state为2时
axios.interceptors.response.use(
  response => {
    //当返回信息为未登录或者登录失效的时候重定向为登录页面
    if (response.data.state == '2') {
      router.push({
        path: 'Login',
        name: '登录'
        // querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
      })
    }
    //关闭遮罩
    tryHideFullScreenLoading()
    return response;
  },
  error => {
    tryHideFullScreenLoading()
    return Promise.reject(error)
  }
)

// 自定义判断元素类型JS
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}

/*
  接口处理函数
  传递的Token参数是登陆后后台生成并保存的随机序列，
  返回给前端后存在cookie里的，
  并且包含在地址栏后面以uid表示
  每次接口都会传递token
  服务器端会根据这个来判断当前账号有没有在其他电脑上登录
  如果接口传递的token与服务器端的不一样，就会返回state不为0的状态，从而下线
*/
function apiAxios(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  params = Qs.stringify(params)
  //  console.log(this.$route)
  // 通过地址栏获得token作为身份标识，如果没有则从cookie中查找
  let Token = GetParam(window.location, "uid")
  if (!Token) Token = getToken() ? getToken() : localStorage.getItem('VIP')

  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: url + '.ashx',
      dataType: "json",
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',

        Token: Token//传递Token参数
      },

      data: method === 'POST' || method === 'PUT' ? params : null,
      params: method === 'GET' || method === 'DELETE' ? params : null,
      baseURL: root,
      timeout:300000,
      withCredentials: false
    }).then(function (res) {
      // console.log('22222')
      // console.log(res.data)
      if (Number(res.data.state) == 0 ) {
        resolve(res.data || res)
      } else {
        //清除遮罩
        // console.log(res.state)
        tryHideFullScreenLoading()

        //给出提示
        if (res.data.state == "3" || res.data.state == "4") {
          console.log(res.data.state)
          resolve(res.data)

          Message.warning({
            message: res.data.result || res.data.error
          });
          // console.log("111")
          //给出提示
        }
        //状态码为1时不弹窗
        // else if(res.data.state == "1"&&window.location.host=="192.168.9.31:8083"){
        else if (res.data.state == "1") {
          resolve(res.data)
          if("error" in res.data){
            Message.warning({
              message: res.data.error
            });
          }else if("msg" in res.data){
            Message.warning({
              message: res.data.msg
            });
          }else{
          Message.warning({
            message: '请求返回数据失败'
          });
        }
        }

        else if (res.data.state == "5") {
          Message.warning({
            message: res.data.errorInfo
          });
        }
        else {
          reject(res.data.result);
        }
      }
    })
      .catch(function (err) {
        reject(err);
      })
  })
}
function apiAxios2(method, url, params, success, failure) {
  // if (params) {
  //   params = filterNull(params)
  // }
  // params = Qs.stringify(params)
  // 通过地址栏获得token作为身份标识，如果没有则从cookie中查找
  let Token = GetParam(window.location, "uid")
  if (!Token) Token = getToken()
  // console.log(Token)
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: url + '.ashx',
      dataType: "json",
      headers: {
        'Content-Type': 'multipart/form-data',

        Token: Token//传递Token参数
      },

      data: method === 'POST' || method === 'PUT' ? params : null,
      params: method === 'GET' || method === 'DELETE' ? params : null,
      baseURL: root,
      timeout:300000,
      withCredentials: false
    }).then(function (res) {
      // console.log(res)
      // if (res.data && Number(res.data.state) === 0 || Number(res.data.state) === 1) {
      if (Number(res.data.state) === 0) {
        resolve(res.data)
      } else {
        //清除遮罩
        tryHideFullScreenLoading()

        //给出提示
        console.log(res.data.state)
        if (res.data.state == "3" || res.data.state == "4") {

          resolve(res.data)

          Message.warning({
            message: res.data.result
          });
          // console.log("111")
          //给出提示
        }
        //状态码为1时不弹窗
        // else if(res.data.state == "1"&&window.location.host=="192.168.9.31:8083"){
        else if (res.data.state == "1") {
          Message.warning({
            message: '请求返回数据失败'
          });
        }

        else if (res.data.state == "5") {
          Message.warning({
            message: res.data.errorInfo
          });
        }
        else {
          reject(res.data.result);
        }
      }
    })
      .catch(function (err) {
        reject(err);
      })
  })
}

function apiAxios1(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }

  params = Qs.stringify(params)
  // 通过地址栏获得token作为身份标识，如果没有则从cookie中查找
  let Token = GetParam(window.location, "uid")
  if (!Token) Token = getToken()
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: `${url}.ashx`,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',

        Token: Token//传递Token参数
      },
      // 'Content-Type': 'application/x-www-form-urlencoded',
      data: method === 'POST' || method === 'PUT' ? params : null,
      params: method === 'GET' || method === 'DELETE' ? params : null,
      baseURL: root,
      withCredentials: false,
      timeout:300000,
    }).then((res) => {
      // console.log(res)
      resolve(res)
      // this.$message.success('下载成功')

    }
    )
      .catch(function (err) {
        reject(err);
      })
  })
}


// 返回在vue模板中的调用接口
export default {
  get: function (url, params, success, failure) {
    return apiAxios('GET', url, params, success, failure)
  },
  post: function (url, params, success, failure) {
    return apiAxios('POST', url, params, success, failure)
  },

  put: function (url, params, success, failure) {
    return apiAxios('PUT', url, params, success, failure)
  },
  delete: function (url, params, success, failure) {
    return apiAxios('DELETE', url, params, success, failure)
  },
  blob: function (url, params, success, failure) {
    return apiAxios1('POST', url, params, success, failure)
  },
  post1: function (url, params, success, failure) {
    return apiAxios2('POST', url, params, success, failure)
  }


}


// WEBPACK FOOTER //
// ./src/api/index.js